export default [
    {
        path: "travel-routes",
        name: "settings-travel-routes",
        redirect: { name: "settings-travel-routes-codes" },
        component: () => import("@/views/settings/views/travel-routes/TravelRoutes.vue"),
        meta: {
            section: 29,
            pageTitle: "Settings",
            breadcrumb: [
                {
                    text: "Travel routes",
                    active: true,
                },
            ],

            tabs: [
                {
                    title: "Codes",
                    name: "settings-travel-routes-codes",
                },
            ],
        },

        children: [
            {
                path: "codes",
                name: "settings-travel-routes-codes",
                component: () => import("@/views/settings/views/travel-routes/components/Codes.vue"),
                meta: {
                    section: 29,
                    tab: "Codes",
                    pageTitle: "Settings",
                    breadcrumb: [
                        {
                            text: "Codes",
                            active: true,
                        },
                    ],
                },
            },             
        ],
    },
];